import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const Container: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }): ReactNode => {
    return (
        <div
            className={cn('mx-auto w-full max-w-6xl px-5 sm:px-8', className)}
            {...props}
        />
    )
}
